export const CONTACT_LINK_CLASSNAME = 'contact-link'
export const INFO_BUTTON_OR_LINK_CLASSNAME = 'info-button-or-link'
export const PRIVACY_POLICY_LINK_CLASSNAME = 'privacy-policy-link'
